var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"fill":"currentColor","d":"M16.627 1.828a1.998 1.998 0 0 1 2.829 0L30.77 13.142a1.998 1.998 0 0 1 0 2.829 1.998 1.998 0 0 1-2.829 0l-1.304-1.304-6.045 7.053a10.502 10.502 0 0 1-.672 7.699l-.089.177a1.988 1.988 0 0 1-1.467 1.078 2.01 2.01 0 0 1-1.737-.561L2.485 15.97a2.002 2.002 0 0 1-.561-1.736 1.975 1.975 0 0 1 1.078-1.467l.177-.089a10.502 10.502 0 0 1 7.699-.672l7.053-6.045-1.304-1.304a1.998 1.998 0 0 1 0-2.829Zm-9.9 21.214 2.83 2.828-4.243 4.243a1.998 1.998 0 0 1-2.829 0 1.998 1.998 0 0 1 0-2.829l4.243-4.242Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h32v32H0z"})))]);
}

Pin.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = Pin;

Pin.default = Pin;
